import { useNavigate, useLocation } from 'react-router-dom';
import { Home, Briefcase, MessageSquare, FileText } from 'lucide-react';
import { useChat } from '../../context/ChatContext';
import { useTier } from '../../context/TierContext';

const TenantMobileLayout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { unreadCount, canUseChat } = useChat();
  const { hasFeature } = useTier();

  const hasQuotes = hasFeature('quotes');

  const navItems = [
    { 
      icon: Home, 
      label: 'Home', 
      path: '/tenant-mobile',
      testId: 'nav-home'
    },
    { 
      icon: Briefcase, 
      label: 'Jobs', 
      path: '/tenant-mobile/jobs',
      testId: 'nav-jobs'
    },
    { 
      icon: FileText, 
      label: 'Quotes', 
      path: '/tenant-mobile/quotes',
      testId: 'nav-quotes',
      hidden: !hasQuotes
    },
    { 
      icon: MessageSquare, 
      label: 'Chat', 
      path: '/tenant-mobile/chat',
      testId: 'nav-chat',
      badge: unreadCount > 0 ? unreadCount : null,
      hidden: !canUseChat
    },
  ];

  const isActive = (path) => {
    if (path === '/tenant-mobile') {
      return location.pathname === '/tenant-mobile' || location.pathname === '/tenant-mobile/';
    }
    return location.pathname.startsWith(path);
  };

  // Filter out hidden items
  const visibleNavItems = navItems.filter(item => !item.hidden);

  return (
    <div className="min-h-screen bg-[#1a1a1a] flex flex-col">
      {/* Main content area */}
      <div className="flex-1 pb-20">
        {children}
      </div>

      {/* Bottom Navigation */}
      <nav className="fixed bottom-0 left-0 right-0 bg-[#2a2a2a] border-t border-gray-700 z-50 safe-area-pb">
        <div className="flex items-center justify-around py-2">
          {visibleNavItems.map((item) => {
            const Icon = item.icon;
            const active = isActive(item.path);
            
            return (
              <button
                key={item.path}
                onClick={() => navigate(item.path)}
                className={`relative flex flex-col items-center py-2 px-4 rounded-lg transition-colors ${
                  active 
                    ? 'text-[#ffd108]' 
                    : 'text-gray-400 hover:text-gray-200'
                }`}
                data-testid={item.testId}
              >
                <div className="relative">
                  <Icon className={`h-6 w-6 ${active ? 'text-[#ffd108]' : ''}`} />
                  {item.badge && (
                    <span className="absolute -top-1 -right-2 bg-[#ffd108] text-black text-[10px] font-bold rounded-full h-4 min-w-[16px] flex items-center justify-center px-1">
                      {item.badge > 9 ? '9+' : item.badge}
                    </span>
                  )}
                </div>
                <span className={`text-xs mt-1 ${active ? 'font-medium' : ''}`}>
                  {item.label}
                </span>
              </button>
            );
          })}
        </div>
      </nav>
    </div>
  );
};

export default TenantMobileLayout;
